export default {
    props: {
        measure: {
            type: String,
        },
        enabled: {
            type: Boolean,
            default: true,
        },
        min: {
            type: Number,
            default: 0
        },
        limitMaxToParent: {
            type: Boolean,
            default: false,
        },
        postResize: {
            type: Function,
            default: () => {
            }
        },
    },
    data() {
        return {
            postResizeFunction: this.postResize
        }
    },
    methods: {
        resizeInput(element) {
            const measure = document.createElement('span')
            measure.className = this.measure + ' absolute opacity-0 whitespace-pre'
            measure.innerText = element.value
            document.body.appendChild(measure)
            let width = Math.max((measure.getBoundingClientRect().width), this.min);
            if (this.limitMaxToParent && this.$el.parentNode) {
                width = Math.min(width,this.$el.parentNode.getBoundingClientRect().width);
            }
            width += 'px';
            element.style.width = 'auto'
            element.style.width = width
            element.style.minWidth = element.style.width
            document.body.removeChild(measure)
            if (this.postResizeFunction) {
                this.postResizeFunction(this);
            }
        },
        resizeEvent(event) {
            this.resizeInput(event.target)
        },
        resizeWindow(event) {
            this.resizeInput(this.$el);
        },
    },
    mounted() {
        if (!this.enabled) {
            return
        }
        this.postResizeFunction = this.postResize
        this.$nextTick(() => {
            this.resizeInput(this.$el)
        })
        this.$el.addEventListener('input', this.resizeEvent)
        window.addEventListener('resize', this.resizeWindow)
    },
    beforeDestroy() {
        delete this.postResizeFunction;
        window.removeEventListener('resize', this.resizeEvent)
        this.$el.removeEventListener('input', this.resizeEvent)
    },
    render() {
        return this.$slots.default[0]
    },
}
